<div class="modal-body">

  <ng-container *ngIf="generatingPDF && !generatingError">
    <div class="text-center py-4">
      <h5>Generating PDF - Please do not leave the page</h5>
      <div class="spinner-border text-success mt-3" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Generating...</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="generatingError">
    <div class="text-center py-4">
      <h5 class="text-danger">An Error Occurred</h5>
      <div class="alert alert-danger mt-2">{{errorMessage}}</div>
    </div>
  </ng-container>

</div>